import React from 'react';
import { Popup } from '@shared/Popup';
import { PopupContent } from './PopupContent';

const SchoolSuspend = () => (
  <Popup overlayColor="rgba(53, 67, 84, 0.9);">
    <PopupContent />
  </Popup>
);

export { SchoolSuspend };
